//通用的lodop常用元素构建方法
import { PrintElement, RenderContext } from '../types/PrintElement';
import { PageManager } from '../manager/PageManager';

export class ElementRenderer {
  private pageManager: PageManager;

  constructor(pageManager: PageManager) {
    this.pageManager = pageManager;
  }

  /**
   * 渲染单个打印元素
   * @param element 打印元素
   * @param context 渲染上下文
   * @returns 处理后的元素top值（可能因分页而改变）
   */
  public renderElement(element: PrintElement, context: RenderContext): number {
    const actualTop = this.resolveElementTop(element);
    const placedElement = {
      ...element,
      top: actualTop
    };

    switch (placedElement.type) {
      case 'text':
        this.renderTextElement(placedElement, context);
        break;
      case 'barcode':
        this.renderBarcodeElement(placedElement, context);
        break;
      case 'line':
        this.renderLineElement(placedElement, context);
        break;
      case 'image':
        this.renderImageElement(placedElement, context);
        break;
      case 'html':
        this.renderHtmlElement(placedElement, context);
        break;
    }

    element.top = actualTop;
    return actualTop;
  }

  public renderMultiLineElements(elements: PrintElement[], context: RenderContext): number {
    let lastTop = 0;

    for (const element of elements) {
      lastTop = this.renderElement(element, context);
    }

    return lastTop;
  }

  private resolveElementTop(element: PrintElement): number {
    if (this.pageManager.isFixedElement(element)) {
      return typeof element.top === 'string' ? parseFloat(element.top) : element.top;
    }

    return this.pageManager.placeElement(element);
  }

  private renderTextElement(element: PrintElement, context: RenderContext): void {
    const { top, left, width, height, content, styles, itemType } = element;
    const contentStr = typeof content === 'string' ? content : String(content || '');
    const escapedContent = contentStr
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/'/g, "\\'")
      .replace(/\n/g, '\\n');
    context.commands.push(`LODOP.ADD_PRINT_TEXT("${top}mm","${left}mm","${width}","${height}","${escapedContent}");`);
    this.applyStyles(styles, context);
    if (itemType !== undefined) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"ItemType",${itemType});`);
    }
  }

  private renderBarcodeElement(element: PrintElement, context: RenderContext): void {
    const { top, left, width, height, content, styles, itemType } = element;
    const contentStr = typeof content === 'string' ? content : String(content || '');
    const escapedContent = contentStr
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/'/g, "\\'")
      .replace(/\n/g, '\\n');
    context.commands.push(`LODOP.ADD_PRINT_BARCODE("${top}mm","${left}mm",${width},${height},"128AUTO","${escapedContent}");`);
    this.applyStyles(styles, context);
    if (itemType !== undefined) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"ItemType",${itemType});`);
    }
  }

  private renderLineElement(element: PrintElement, context: RenderContext): void {
    const { content, itemType } = element;
    const [x1, y1, x2, y2, lineWidth, lineStyle] = content.split(',').map(Number);
    context.commands.push(`LODOP.ADD_PRINT_LINE("${x1}mm", "${y1}mm", "${x2}mm", "${y2}mm", ${lineWidth}, ${lineStyle});`);
    if (itemType !== undefined) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"ItemType",${itemType});`);
    }
  }

  private renderImageElement(element: PrintElement, context: RenderContext): void {
    const { top, left, width, height, content, styles, itemType } = element;
    context.commands.push(`LODOP.ADD_PRINT_IMAGE("${top}mm","${left}mm","${width}","${height}","${content}");`);
    this.applyStyles(styles, context);
    if (itemType !== undefined) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"ItemType",${itemType});`);
    }
  }

  private renderHtmlElement(element: PrintElement, context: RenderContext): void {
    const { top, left, width, height, content, styles, itemType } = element;
    context.commands.push(`LODOP.ADD_PRINT_HTM("${top}mm", "${left}mm", "${width}", "${height}", \` ${content} \`);`);
    this.applyStyles(styles, context);
    if (itemType !== undefined) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"ItemType",${itemType});`);
    }
  }

  private applyStyles(styles: any, context: RenderContext): void {
    if (!styles) return;

    for (const [key, value] of Object.entries(styles)) {
      context.commands.push(`LODOP.SET_PRINT_STYLEA(0,"${key}","${value}");`);
    }
  }

  public renderElements(elements: PrintElement[], context: RenderContext): void {
    for (const element of elements) {
      this.renderElement(element, context);
    }
  }
}
